export const getPhysicalInfo = function(data = {}) {
    let baseInfo = {
        deviceName: getDeviceName(),
        operatingSystem: getUserOsInfo(),
        browserInfo: getBrowserType(),
    } 
    data.physicalInfo = baseInfo;
}

function getDeviceName() {
    let userAgent = navigator.userAgent;
    let mobiles = ['Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'IEMobile', 'Opera Mini', 'Mobile'];
    for (let i = 0, len = mobiles.length; i < len; i++) {
        let name = mobiles[i];
        if (userAgent.indexOf(name) !== -1) {
            return name
        }
    }
    if (userAgent.indexOf("Mac") !== -1) {
        return 'Mac';
    }
    return 'PC';
}

export function getUserOsInfo() {
    const userAgent = navigator.userAgent;
    let os = 'Others'
    if (userAgent.indexOf("Android") !== -1) {
        os = "Android";
    } else if (userAgent.indexOf("Windows NT 10.0") !== -1) {
        os = "Windows 10";
    } else if (userAgent.indexOf("Windows NT 6.2") !== -1) {
        os =  "Windows 8";
    } else if (userAgent.indexOf("Windows NT 6.1") !== -1) {
        os =  "Windows 7";
    } else if (userAgent.indexOf("Windows NT 6.0") !== -1) {
        os =  "Windows Vista";
    } else if (userAgent.indexOf("Windows NT 5.1") !== -1) {
        os =  "Windows XP";
    } else if (userAgent.indexOf("Windows NT 5.0") !== -1) {
        os =  "Windows 2000";
    } else if (userAgent.indexOf("Mac") !== -1) {
        os =  "Mac/iOS";
    } else if (userAgent.indexOf("X11") !== -1) { 
        os =  "UNIX";
    } else if (userAgent.indexOf("Linux") !== -1) {
        os =  "Linux";
    } 
    return os;
}

// 获取浏览器类型
export function getBrowserType() {
    let ua = navigator.userAgent.toLocaleLowerCase()
    let browserType = 'Others'
    if (ua.match(/edge/) != null) {
        browserType = 'Edge'
    } else if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        browserType = 'IE'
    } else if (ua.match(/firefox/) != null) {
        browserType = 'Firefox'
    } else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
        browserType = 'Opera'
    } else if (ua.match(/chrome/) != null || ua.match(/crios/) != null) {
        browserType = 'Chrome'
    } else if (ua.match(/safari/) != null) {
        browserType = 'Safari'
    } 
    return browserType
}



